
interface QuoteSectionProps {
  onQuoteClick: () => void;
}

export default function QuoteSection({ onQuoteClick }: QuoteSectionProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
          まずは 1 分で無料見積
        </h2>
        <p className="text-xl text-blue-100 mb-10">
          必要な論文情報を送るだけで、すぐに見積をお届けします
        </p>
        
        <button 
          onClick={onQuoteClick}
          className="group bg-white text-blue-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-50 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
        >
          <i className="ri-file-list-3-line text-xl"></i>
          無料見積もりを依頼する
          <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
        </button>
      </div>
    </section>
  );
}